import { InitCommand } from "slotworks/commands/comms/init-command";
import { SetupStandardStateControlsCommand } from "slotworks/commands/setup/setup-standard-state-controls-command";
import Components from "slotworks/components/components";
import Layers from "slotworks/graphics/layers/layers";
import GameState from "slotworks/model/game-state";
import SettingsModel from "slotworks/model/settings/settings-model";
import { Services } from "slotworks/services/services";
import { SoundEvent } from "slotworks/services/sound/sound-events";
import SmartUIFlags from "slotworks/smart-ui/smart-ui-flags";
import { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import State from "slotworks/state-machine/states/state";
import Contract from "slotworks/utils/contracts/contract";
import Sequence from "slotworks/utils/contracts/sequence";
import Timer from "slotworks/utils/timer";

export default class Init extends State {

    // Number of milliseconds before dispatching game inactive sound event
    public static GAME_INACTIVE_TIME: number = 5000;

    private inactiveTimer: number;

    public onEnter() {
        this.setupGameInactiveTimer();

        new Sequence([
            () => InitCommand(),
            () => this.startGame()
        ]).then(() => this.complete());
    }

    protected setupStateControls() {
        SetupStandardStateControlsCommand();
    }

    protected startGame() {
        this.setupStateControls();
        Layers.jumpToDefaultScene();
        Components.init();

        Services.transaction.setBalance(GameState.getCurrentGame().startBalance);

        Components.header.setMode(SettingsModel.playMode);

        GameState.getCurrentGame().latestRecord();

        return this.enableSound();
    }

    protected enableSound() {
        if (!Services.sound.getMuted()) {
            Services.sound.unmute();
        }

        return Contract.empty();
    }

    protected setupGameInactiveTimer() {
        SmartUIFlags.onFlagsUpdated.add((flags: number) => {
            if ((flags & SmartUIFlag.IDLE) === SmartUIFlag.IDLE) {
                this.startInactiveTimer();
            } else {
                this.cancelInactiveTimer();
            }
        });
    }

    private startInactiveTimer() {
        if (!this.inactiveTimer) {
            this.cancelInactiveTimer();
            this.inactiveTimer = Timer.setTimeout(() => Services.sound.customEvent(SoundEvent.game_inactive), Init.GAME_INACTIVE_TIME);
        }
    }

    private cancelInactiveTimer() {
        Timer.clearTimeout(this.inactiveTimer);
        this.inactiveTimer = null;
    }
}
